import type { AgGridReact } from 'ag-grid-react';
import { useEffect, useRef, type RefObject } from 'react';

/**
 * Purges SSRM cache when `revision` changes (e.g. global org filter).
 * Skips the first run so initial load is not double-fetched.
 */
export function useRefreshServerSideWhen<TData>(
  gridRef: RefObject<AgGridReact<TData> | null>,
  revision: unknown
): void {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    gridRef.current?.api?.refreshServerSide({ purge: true });
  }, [gridRef, revision]);
}
